import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Main from "./pages/Main";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

/**기업소개 */
import GNBPURE00000S from "./pages/company/GNBPURE00000S";  /**ceo인사말 */
import GNBPURE00001S from "./pages/company/GNBPURE00001S";  /**ABOUT US */
import GNBPURE03001S from "./pages/company/GNBPURE03001S";  /**GNB소식 */
import GNBPURE03002S from "./pages/company/GNBPURE03002S";  /**GNB소식 */
import GNBPURE00002S from "./pages/company/GNBPURE00002S";  /**사업실적 */
import GNBPURE00003S from "./pages/company/GNBPURE00003S";  /**오시는길 */

/**사업분야 */
import GNBPURE01001S from "./pages/business/GNBPURE01001S"; // 시스템통합 (SI)
import GNBPURE01002S from "./pages/business/GNBPURE01002S"; // 시스템유지보수 (SM)
import GNBPURE01003S from "./pages/business/GNBPURE01003S"; // 솔루션제공
import GNBPURE01004S from "./pages/business/GNBPURE01004S"; // 애플리케이션서비스제공 (ASP)
import GNBPURE01005S from "./pages/business/GNBPURE01005S"; // IT컨설팅서비스

/**제품소개 */
import GNBPURE02000S from "./pages/solution/GNBPURE02000S"; // 온라인대출
import GNBPURE02001S from "./pages/solution/GNBPURE02001S"; // 스탁론
import GNBPURE02002S from "./pages/solution/GNBPURE02002S"; // NPL
import GNBPURE02003S from "./pages/solution/GNBPURE02003S"; // 기관연계시스템
import GNBPURE02004S from "./pages/solution/GNBPURE02004S"; // 통합솔루션

/**고객지원 */
import GNBPURE04001S from "./pages/support/GNBPURE04001S";  /**제휴문의 */
import GNBPURE04002S from "./pages/support/GNBPURE04002S";  /**공지사항 */
import GNBPURE04003S from "./pages/support/GNBPURE04003S";  /**공지사항 */

/** 인재 채용 */
import GNBPURE06001S from "./pages/recruit/GNBPURE06001S"; /**인재상 */ 
import GNBPURE06002S from "./pages/recruit/GNBPURE06002S"; /**복리후생 */
import GNBPURE06003S from "./pages/recruit/GNBPURE06003S"; /**채용공고 목록 */
import GNBPURE06004S from "./pages/recruit/GNBPURE06004S"; /**채용공고 상세 */

/** 메인페이지 하단 부분*/
import GNBPURE05001S from "./pages/common/GNBPURE05001S"; /** 개인정보처리방침 */
import GNBPURE05002S from "./pages/common/GNBPURE05002S"; /** 이용약관 */
import GNBPURE05003S from "./pages/common/GNBPURE05003S"; /** 이메일무단수집공고 */

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main />} />
	      <Route path="/GNBPURE00000S" element={<GNBPURE00000S />} />
	      <Route path="/GNBPURE00001S" element={<GNBPURE00001S />} />
        <Route path="/GNBPURE03001S" element={<GNBPURE03001S />} />
        <Route path="/GNBPURE03002S" element={<GNBPURE03002S />} />
	      <Route path="/GNBPURE00002S" element={<GNBPURE00002S />} />
	      <Route path="/GNBPURE00003S" element={<GNBPURE00003S />} />

        <Route path="/GNBPURE01001S" element={<GNBPURE01001S />} />
        <Route path="/GNBPURE01002S" element={<GNBPURE01002S />} />
        <Route path="/GNBPURE01003S" element={<GNBPURE01003S />} />
        <Route path="/GNBPURE01004S" element={<GNBPURE01004S />} />
        <Route path="/GNBPURE01005S" element={<GNBPURE01005S />} />

        <Route path="/GNBPURE02000S" element={<GNBPURE02000S />} />
        <Route path="/GNBPURE02001S" element={<GNBPURE02001S />} />
        <Route path="/GNBPURE02002S" element={<GNBPURE02002S />} />
        <Route path="/GNBPURE02003S" element={<GNBPURE02003S />} />
        <Route path="/GNBPURE02004S" element={<GNBPURE02004S />} />
        
        <Route path="/GNBPURE04001S" element={<GNBPURE04001S />} />
	      <Route path="/GNBPURE04002S" element={<GNBPURE04002S />} />
	      <Route path="/GNBPURE04003S" element={<GNBPURE04003S />} />

        <Route path="/GNBPURE06001S" element={<GNBPURE06001S />} />
        <Route path="/GNBPURE06002S" element={<GNBPURE06002S />} />
        <Route path="/GNBPURE06003S" element={<GNBPURE06003S />} />
        <Route path="/GNBPURE06004S" element={<GNBPURE06004S />} />

        <Route path="/GNBPURE05001S" element={<GNBPURE05001S />} />
        <Route path="/GNBPURE05002S" element={<GNBPURE05002S />} />
        <Route path="/GNBPURE05003S" element={<GNBPURE05003S />} />

      </Routes>
    </Router>
  );
}
 

export default App;
